
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/passive-explanation';
const mainimage = '/Images/passive1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "passive" },
];


const Passive = () => (
  <GrammarPageLayout
    level="B1"
    title="Passive"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Passive Exercises"
    seoDescription="Focus on the action rather than the doer with passive voice structures. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Passive;
